
import getCustomization from '../utils/get-customization'

export const theme = getCustomization().theme


